import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';

export default function GenericErrorDialog({
  title,
  description,
  onCancel,
  action = null,
}) {
  return (
    <Dialog open maxWidth='sm'>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{description}</DialogContent>
      <DialogActions>
        <Button
          onClick={action != null ? action : onCancel}
          variant='contained'
          color='primary'
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
